// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.internal-info-container {
  display: block;
  min-height: 100vh;
  margin-left: 15px;
  margin-right: 15px;
  max-width: 100%;
  overflow: hidden;
}

app-sidebar {
  display: flex;
  min-height: 92vh;
}

.main-container {
  width: 95%;
  height: 90vh;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.iframe-container {
  display: flex;
  height: 100%;
  width: 100%;
}

.survey-iframe {
  display: flex;
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 30px 0px 0px 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/lbarometer/lb-survey/lb-survey.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EAEA,eAAA;EACA,gBAAA;AAAJ;;AAGE;EACE,aAAA;EACA,gBAAA;AAAJ;;AAGE;EAEE,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,2BAAA;AADJ;;AAGE;EACE,aAAA;EACA,YAAA;EACA,WAAA;AAAJ;;AAIE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EAGA,gCAAA;AAHJ","sourcesContent":[".internal-info-container {\n    display: block;\n    min-height: 100vh;\n    margin-left: 15px;\n    margin-right: 15px;\n    //justify-content: center;\n    max-width: 100%;\n    overflow: hidden;\n  }\n\n  app-sidebar {\n    display:flex;\n    min-height:92vh\n  }\n\n  .main-container {\n    //margin-top:30px;\n    width:95%;\n    height:90vh;\n    display:flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n  .iframe-container {\n    display:flex;\n    height:100%;\n    width:100%;\n\n  }\n\n  .survey-iframe {\n    display:flex;\n    width:100%;\n    height: 100%;\n    border:none;\n    //overflow:hidden;\n    //transform:scale(0.8);\n    border-radius:30px 0px 0px 30px;\n\n  }\n\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
